export default "__VITE_ASSET__BzxoYHOE__"